import React from "react";
import {
  Mail,
  Phone,
  MapPin,
  Facebook,
  Twitter,
  Instagram,
  Linkedin,
  ArrowRight,
} from "lucide-react";
import "../styles/Footer.css";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="main-footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-col brand-col">
            <img
              src="https://res.cloudinary.com/dxgkcyfrl/image/upload/v1767593282/logo1_ssbtzf.png"
              alt="Rift Nakuru Logo"
              className="footer-logo"
            />
            <p className="footer-description">
              Rift Nakuru Insurance Agencies Ltd is a premier provider of
              comprehensive insurance solutions. Licensed by the Insurance
              Regulatory Authority (IRA), we specialize in securing the futures
              of families and businesses across Kenya.
            </p>
            <div className="social-links">
              <a href="/" aria-label="Facebook">
                <Facebook size={18} />
              </a>
              <a href="/" aria-label="Twitter">
                <Twitter size={18} />
              </a>
              <a href="/" aria-label="LinkedIn">
                <Linkedin size={18} />
              </a>
              <a href="https://www.instagram.com/riftnakuruins?igsh=MTFib3prYWVxYnB0aw==" aria-label="Instagram">
                <Instagram size={18} />
              </a>
            </div>
          </div>
          <div className="footer-col">
            <h3 className="footer-title">Personal Protect</h3>
            <ul className="footer-links">
              <li>
                <a href="/">
                  <ArrowRight size={14} /> Motor Private
                </a>
              </li>
              <li>
                <a href="/">
                  <ArrowRight size={14} /> Medical Cover
                </a>
              </li>
              <li>
                <a href="/">
                  <ArrowRight size={14} /> Travel Insurance
                </a>
              </li>
              <li>
                <a href="/">
                  <ArrowRight size={14} /> Domestic Package
                </a>
              </li>
              <li>
                <a href="/">
                  <ArrowRight size={14} /> Education Policy
                </a>
              </li>
            </ul>
          </div>
          <div className="footer-col">
            <h3 className="footer-title">Quick Links</h3>
            <ul className="footer-links">
              <li>
                <a href="/claims">
                  <ArrowRight size={14} /> Report a Claim
                </a>
              </li>
              <li>
                <a href="/quote">
                  <ArrowRight size={14} /> Get a Quote
                </a>
              </li>
              <li>
                <a href="/about-us/our-leadership">
                  <ArrowRight size={14} /> Our Leadership
                </a>
              </li>
              <li>
                <a href="/about-us/who-are-we">
                  <ArrowRight size={14} /> About Us
                </a>
              </li>
              <li>
                <a href="/contact">
                  <ArrowRight size={14} /> Contact Us
                </a>
              </li>
            </ul>
          </div>
          <div className="footer-col contact-col">
            <h3 className="footer-title">Get In Touch</h3>
            <div className="contact-item">
              <MapPin size={22} className="contact-icon" />
              <p>
                Corner of Digo Drive Road / Massai Avenue P.O BOX 2727 Nakuru, 20100, Kenya
              </p>
            </div>
            <div className="contact-item">
              <Phone size={20} className="contact-icon" />
              <p>
                +254 721 498898
              </p>
            </div>
            <div className="contact-item">
              <Mail size={20} className="contact-icon" />
              <p>insure@riftnakuru.com</p>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <div className="bottom-flex">
            <p>
              &copy; {currentYear} Rift Nakuru Insurance Agencies Ltd. All
              Rights Reserved.
            </p>
            <div className="legal-links">
              <a href="/">Privacy Policy</a>
              <a href="/">Terms of Use</a>
              <a href="/">IRA License: IRA/00/000</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
